var SENTRY_RELEASE;SENTRY_RELEASE={name: "Radio-Canada", version: "1.108.0"};